<template>
  <div>
    <iframe :src=iframeSrc ref="playiframe" class="w-100 vh-95"/>
  </div>
</template>

<script>

import rootAccessor from '@/mixins/root-accessor'

export default {
  name: 'Play',
  mixins: [rootAccessor],
  data(){
    return {
      iframeSrc : ""
    }
  },
  created () {
    this.addBodyClass('no-menue')
    this.iframeSrc = window.localStorage.getItem('productUrl')
  },
  beforeDestroy () {
    this.clearBodyClass()
  }
}
</script>
